// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"35d5accd","239":"e263d32e","455":"ecef185b","762":"2930e31b"}[chunkId] + ".chunk.js";
};